var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDubbing = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 13,
  height: 13,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.903,
  d: "m2.092 4.048 1.345 1.01a.66.66 0 0 0 .986-.232.66.66 0 0 1 .428-.343l1.09-.274a.98.98 0 0 0 .709-.71l.435-1.74m3.447 4.26a4.514 4.514 0 1 1-9.028 0 4.514 4.514 0 0 1 9.028 0M5.73 8.024l-.413-.62a.6.6 0 0 1 .538-.931l.415.026a1 1 0 0 1 .482.164l.688.462a.729.729 0 0 1-.407 1.333h-.491a.98.98 0 0 1-.812-.434"
})));
export default SvgDubbing;